import { useEffect, useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { ProfileJobJunction } from "@/models/ProfileJobJunction";

export const useProfileJobJunction = (job_id: string) => {
  const user = useCurrentUserProfile((s) => s.user);
  const [status, setStatus] = useState<ProfileJobJunction | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async (id: string, uid: string) => {
    setLoading(true);
    setError(null);
    try {
      const docRef = collectionRef.ProfileJobJunction.doc(`${uid}_${id}`);
      const docSnapshot = await docRef.get();
      if (docSnapshot.exists()) {
        setStatus({
          ...docSnapshot.data(),
          id: docSnapshot.id,
        } as ProfileJobJunction);
      }
      setLoading(false);
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  const refetch = () => {
    fetchData(job_id, user.uid);
  };

  useEffect(() => {
    if (!status) {
      fetchData(job_id, user.uid);
    }
  }, [status, job_id]);

  return {
    data: status,
    loading,
    error,
    refetch,
  };
};
